export default __webpack_public_path__ + "static/media/logout.851f12cd.svg";